/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineRuleCondition extends models.TagBaselineRule {
    constructor() {
        super();
        this.setDiscriminator("TagBaselineRuleCondition");
    }

    getFixupPrototypeFunction() { return TagBaselineRuleCondition.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineRuleCondition>): TagBaselineRuleCondition {
        let obj = Object.assign(new TagBaselineRuleCondition(), model);
        TagBaselineRuleCondition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineRuleCondition>): TagBaselineRuleCondition {
        if (!model) return null;
        return TagBaselineRuleCondition.newInstance(<TagBaselineRuleCondition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineRuleCondition) {
        if (!obj) return;

        models.TagBaselineRuleCondition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineRuleCondition): boolean {
        if (models.TagBaselineRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineRuleCondition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed values should start with this text
     */
    starts_with: string;

    /**
     * Allowed values should contain this text
     */
    contains: string;

    /**
     * Allowed values should end with this text
     */
    ends_with: string;

}
